var _path, _path2, _circle, _rect, _rect2, _rect3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgWorker = function SvgWorker(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 40 40"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "currentColor",
    strokeWidth: 2,
    d: "M5 25.62C5 21.42 8.41 18 12.62 18h8.76c4.2 0 7.62 3.41 7.62 7.62 0 .2-.17.38-.38.38H5.38a.38.38 0 0 1-.38-.38Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "currentColor",
    strokeWidth: 2,
    d: "M16.1 13.97a1 1 0 0 1 1.8 0l1.9 4.11a1 1 0 0 1 0 .84l-1.9 4.11a1 1 0 0 1-1.8 0l-1.9-4.11a1 1 0 0 1 0-.84l1.9-4.11Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 10,
    r: 6,
    fill: "#fff",
    stroke: "currentColor",
    strokeWidth: 2
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 10,
    x: 20,
    y: 25,
    fill: "#fff",
    stroke: "currentColor",
    strokeWidth: 2,
    rx: 1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 4,
    x: 24,
    y: 21,
    fill: "#fff",
    stroke: "currentColor",
    strokeWidth: 2,
    rx: 1
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 1,
    x: 20.5,
    y: 29.5,
    fill: "#fff",
    stroke: "currentColor",
    rx: 0.5
  })));
};
export default SvgWorker;